export const PURGE_AUTH = 'logOut'
export const SET_AUTH = 'setUser'
export const RESET_STATE = 'resetModuleState'
